import axios from "axios"

// Rutas de autenticación: un 401 aquí es una credencial inválida, no una sesión
// expirada, así que no deben disparar la redirección.
const isAuthEndpoint = (url = "") => /auth\/login|recoveryPass/i.test(url)

let handled = false

/**
 * Limpia la sesión y manda al usuario al login, marcando el motivo para que
 * la pantalla de login pueda avisarle que su sesión venció.
 */
export const handleSessionExpired = () => {
    if (handled) return
    handled = true

    window.sessionStorage.removeItem("token")
    window.sessionStorage.removeItem("user")

    window.location.href = "/login?session=expired"
}

// Cubre todos los servicios que usan axios directamente (la mayoría del proyecto).
axios.interceptors.response.use(
    (response) => response,
    (error) => {
        const status = error?.response?.status
        const url = error?.config?.url || ""
        if (status === 401 && !isAuthEndpoint(url)) {
            handleSessionExpired()
        }
        return Promise.reject(error)
    }
)

// Cubre las llamadas con fetch nativo (src/providers/api.js).
const originalFetch = window.fetch.bind(window)
window.fetch = async (...args) => {
    const response = await originalFetch(...args)
    const url = typeof args[0] === "string" ? args[0] : args[0]?.url || ""
    if (response.status === 401 && !isAuthEndpoint(url)) {
        handleSessionExpired()
    }
    return response
}
